<crud-list class="col-12" [data]="table" detailUrl="/base2/admin/editGeneralUserGroup/" restUrl="api/app/userGroup">
</crud-list>
